import shared from './shared.json';
import v1_0 from './v1-0/v1-0.json';
import utils from './shared';

export const PRECISION_BIOME_WOMENS_HEALTH_V1_0 = v1_0;
export const PRECISION_BIOME_WOMENS_HEALTH_VERSIONS = [
	{
		label: '1.0',
		value: '1.0',
	},
];

export const PRECISION_BIOME_WOMENS_HEALTH: { [key: string]: any } = {
	shared: shared,
	'1.0': PRECISION_BIOME_WOMENS_HEALTH_V1_0,
};

export const PRECISION_BIOME_WOMENS_HEALTH_UTILS = utils;
